import { useContext } from 'react';
import { SmartContext } from '../../../../library/Core/SmartContext';
import { getDomainValueForCode } from '../../../../library/Core/SmartFunctions';

const PurposeOfOutreach = () => {
    const { state } = useContext(SmartContext);
    const purposes = state.data.purposeOfOutreach;

    return (
        <div className="bg-white p-4 custom-shadow h-100 radius-6">
            <h5 className="col font-18 font-600 mb-3">Purpose of Outreach</h5>
            {purposes.length === 0 ? (
                <p className="font-14 text-gray-64">No outreach data available.</p>
            ) : (
                <div className="d-flex flex-column gap-2 overflow-y-auto pe-1" style={{ maxHeight: '268px' }}>
                    {purposes.map((item: any, index: number) => (
                        <div
                            key={index}
                            className="list-item d-flex justify-content-between align-items-center px-3 py-3 bg-gray-F2F4F7 rounded-3">
                            <span className="text-dark font-500">{getDomainValueForCode(item.label, 'OUTREACH_PURPOSE_CATEGORY_CODE', state)}</span>
                            <span className="bg-success bg-opacity-10 px-3 py-1 rounded-pill font-14 font-500 text-success">
                                {item.count}
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default PurposeOfOutreach;
